var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('div',{staticClass:"pt-3"},[_c('StatManagement')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }